import { ColorField } from './types'

export const MESSAGE_MAX_LENGTH = 140

export const SAVE_FAILED_MESSAGE = 'That could not be saved. Please try again.'

export const DELETE_FAILED_MESSAGE = 'That message could not be deleted. Please try again.'

export const HEX_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/

/** Stand-ins for a colour the operator has not finished typing, so the preview never goes invalid. */
export const NEUTRAL_SURFACE = '#E5E7EB'
export const NEUTRAL_INK = '#1F2937'

export const COLOR_FIELDS: ColorField[] = [
  'brandColorPrimary',
  'fontColorPrimary',
  'specialBallColor',
]

export const LOAD_FAILED_MESSAGE = 'Promotional messages could not be loaded. Please try again.'

export const GAMES_LOAD_FAILED_MESSAGE = 'Games could not be loaded. Please try again.'

export const REORDER_FAILED_MESSAGE = 'The new game order could not be saved. Please try again.'

export const GAME_NOT_FOUND_MESSAGE = 'That game could not be found.'

export const GAME_LOAD_FAILED_MESSAGE = 'That game could not be loaded. Please try again.'

export const APPEARANCE_SAVED_MESSAGE = 'Appearance saved.'
